import React, { Component } from 'react';

import AsideView from '@uicomponents/AsideView';
import Loader from '@uicomponents/Loader';

import Business from '@models/business/Business';

import BusinessForm from './BusinessForm';

export default class CreateBusinessPage extends Component {
  componentDidMount() {
    const { onChange, targetName } = this.props;
    const newBusiness = new Business();
    newBusiness.name = targetName || '';
    onChange('formBusiness', newBusiness);
  }

  render() {
    const { t, formBusiness, businessIsFetching, createBusiness } = this.props;

    if (!formBusiness || businessIsFetching) {
      return (
        <div className="absolute-center">
          <Loader />
        </div>
      );
    }

    return (
      <AsideView>
        <h1 className="no-margin-bottom">{t('business.new')}</h1>
        <BusinessForm
          {...this.props}
          onSubmit={(business) => createBusiness(business)}
        />
      </AsideView>
    );
  }
}
